import * as React from 'react';

import {FlaggedFormModel} from '../../../model/FlaggedFormModel';
import './pagination.scss';

export interface IPaginationProps {
    instances?: FlaggedFormModel[];
    currentPage?: number;
    handlePageNumbers?: Function;
}

export class Pagination extends React.PureComponent<IPaginationProps, {}> {
    constructor(props: IPaginationProps) {
        super(props);
    }
    render() {
        const { instances, currentPage } = this.props;
            let pageNumberArray = [];
            const pageNumbers = instances[0] && instances[0].props.PagesCount;
            for (let i = 1 ; i <= pageNumbers; i++) {
                pageNumberArray[i - 1] = i;
            }
            return (
                <ul className="pagination">
                        {pageNumberArray.map((page, index) => (
                            <li key={index} className={(index + 1) === currentPage ? 
                                'active-pagination-item' : 'inactive-pagination-item'} 
                            onClick={() => this.props.handlePageNumbers(index + 1)}>
                            {page}
                            </li>
                        ))}
                </ul>
            );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/Pagination/pagination.tsx